export const APP_SHELL_CONSTANTS = {
  STORAGE: {
    SITE_NAME: 'whiteLabelSiteName',
    THEME_COLORS: 'whiteLabelThemeColors'
  },
  STYLE_IDS: {
    SSR_THEME: 'ssr-theme-variables'
  },
  BODY: {
    HYDRATED: 'hydrated',
    HAS_BACKGROUND_IMAGE: 'has-background-image',
    SOCIAL_CALLBACK_BOOT: 'social-callback-boot',
    WHITE_LABEL: 'theme-whiteLabel'
  },
  QUERY: {
    PREVIEW: 'preview',
    EMBED: 'embed',
    IS_EMAIL: 'is_email',
    IS_TEXT_LOGO: 'is_text_logo',
    TRUE: 'true'
  },
  INPUT: {
    EMAIL: 'email',
    EMBED_LINK: 'embed_link',
    TEXTAREA: 'TEXTAREA',
    INPUT: 'INPUT'
  },
  SERVICE_WORKER: {
    SCRIPT: '/offline.service.js',
    RELOAD_PAGE: 'RELOAD_PAGE'
  },
  DEFAULT_LOGO: '/assets/favicon/TopFans_180.png',
  FALLBACK_SSR_COLORS: {
    bgColor: '#191a1c',
    secondaryBgColor: '#000000',
    backgroundImage: null
  },
  PREVIEW_COLOR_KEYS: [
    'bg_color',
    'bg_text_color',
    'secondary_bg_color',
    'post_text_color',
    'theme_color',
    'button_text_color',
    'background_image'
  ],
  PREVIEW_CONFIG_PARAMS: [
    'logo_url',
    'background_image',
    'bg_color',
    'bg_text_color',
    'secondary_bg_color',
    'button_text_color',
    'post_text_color',
    'theme_color',
    'user_text',
    'user_font'
  ],
  REFERENT_PARAMS: [
    'birth_date',
    'gender',
    'email',
    'first_name',
    'last_name',
    'general_location'
  ],
  CSS_VAR_MAP: {
    bg_color: '--configBgColor',
    theme_color: '--configThemeColor',
    secondary_bg_color: '--configSecondaryBgColor',
    post_text_color: '--configPostTextColor',
    button_text_color: '--configButtonTextColor',
    bg_text_color: '--configBgTextColor'
  },
  HISTORY_LIMIT: 15,
  INPUT_SANITIZE_DEBOUNCE_MS: 500,
  HIDDEN_SIDEBAR_PATHS: [
    '/auth',
    '/privacy-policy',
    '/terms-conditions',
    '/contact-us',
    '/about',
    '/pricing',
    '/advertise',
    '/terms-of-service',
    '/help-faq',
    '/share',
    '/access-user',
    '/not-found',
    '/unsubscribe-instruction',
    '/unsubscribe/newsletter',
    '/imported/opt-out',
    '/shopify-connect',
    '/calendar-connect',
    '/order-status',
    '/bio',
    '/monetize/redeem-ticket',
    '/creator',
    '/creators',
    '/post/',
    '/wls/',
    '/home/',
    '/global/',
    '/edit-preference/whitelabel-cover-page',
    '/edit-preference/become-a-creator/',
    '/edit-preference/whitelabel/landing-builder',
    '/content/',
    '/request-demo',
    '/schedule-a-demo'
  ],
  TOPFANS_ONLY_HIDDEN_SIDEBAR_PATHS: ['/edit-preference/whitelabel']
} as const;

export type WhiteLabelThemeColors = {
  bgColor?: string;
  themeColor?: string;
  secondaryBgColor?: string;
  postTextColor?: string;
  buttonTextColor?: string;
  bgTextColor?: string;
  backgroundImage?: string | null;
};
